import React from 'react';
import PropTypes from 'prop-types';

const Header = ({
  openLabel,
  closedLabel,
  holdLabel,
  lastUpdated,
  getIcon
}) => (
  <div className="lift-status-report__header">
    <ul className="lift-status-report__legend">
      <li>
        <svg className="lift-status-report__open-icon">
          <title>Open</title>
          <use xlinkHref={getIcon('open')} />
        </svg>
        {openLabel}
      </li>
      <li>
        <svg className="lift-status-report__closed-icon">
          <title>Close</title>
          <use xlinkHref={getIcon('closed')} />
        </svg>
        {closedLabel}
      </li>
      <li>
        <svg className="lift-status-report__hold-icon">
          <title>Hold</title>
          <use xlinkHref={getIcon('hold')} />
        </svg>
        {holdLabel}
      </li>
    </ul>
  </div>
);

Header.propTypes = {
  openLabel: PropTypes.string.isRequired,
  closedLabel: PropTypes.string.isRequired,
  holdLabel: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  getIcon: PropTypes.func.isRequired
};

export default Header;
